import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
  urlString } from
"../../utils/common-utils";
import { useLocation, useNavigate } from "@remix-run/react";

import { Box, Image, useBreakpointValue } from "@chakra-ui/react";
import PlainInput from "../ai-tutor/Editor/PlainInput";
import { commonProps } from "./reviewUtils";
import { getChatInfoByIds } from "../../network/TutorApiService";
import { getJourneyInfo } from "../../api/task-services";
import pkg from "@inrscr/coschool-ui-components";
import { useCustomToast } from "../../components/molecules/ai-tutor/useCustomToast";
import { usePractice } from "../../context/PracticeContext";
import { useRoot } from "../../context/RootContext";
import useStateRef from "react-usestateref";
import LearnSideNav from "../../components/molecules/learnSideNav/learnSideNav";
import { learningModes } from "../../utils/LearningPathUtils";
import loading from "../../assets/loading.json";
import Lottie from "react-lottie-player";
import { useTutor } from "../../context/AiTutorContext";
import { TutorReviewModeStyles } from "./TutorReviewModeStyles";
import PracticeStyles from "../ai-tutor/Practice/practice.module.css";
import PracticeHistoryList from "../ai-tutor/Practice/PracticeHistoryList";
import RightArrowIcon from "../../assets/svgs/RightArrowicon.svg";
import PracticeHistoryBottomSheet from "../ai-tutor/Practice/PracticeHistoryBottomSheet";
import { StorageService } from "../../utils/StorageUtils";
import accordion_images from "../../utils/accordion/accordion_images";
import { usePendingChatUpdater } from "./usePendingChatUpdater";
import { getAuthToken } from "../../api/login-service";
import {
  handleExtractAnswerImages,
  handleExtractQuestionImages } from
"../../utils/TutorConstants";
const TutorReviewMode = ({
  journeyId,
  subjectMasterUuid,
  topicMasterUuid,
  isExecutionHistory = false,
  isHistoryLoaded
}) => {
  const { ReviewPresenter } = pkg;
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useCustomToast();
  const isReviewRoute = location.pathname?.includes(`/review`);
  const {
    setReviewScreen,
    setTaskType,
    setSubjectName,
    setTopicName,
    setSubTopicName,
    openLearnSideMenu,
    toggleLearnDrawer,
    isStandaloneWithSubjectMapping,
    isStandalone,
    openPracSideMenu,
    togglePracDrawer,
    setExecutionHistoryLoaded,
    setReviewQuestionsData
  } = useRoot();
  const {
    setDisplayedQues,
    displayedQues,
    setChatHistory,
    chatHistory,
    setCurrentQuestionIndex,
    assistantRefImages,
    setAssistantRefImages
  } = usePractice();
  const isMobile = useBreakpointValue({ base: true, md: true, lg: false });

  const { selectedTopic } = useTutor();
  const { setClearAllBottomButtons, buttons } = usePractice();
  const [questionsData, setQuestionsData, questionsDataRef] = useStateRef([]);
  const [journeyData, setJourneyData, journeyDataRef] = useStateRef([]);
  const [journeyType, setJourneyType, journeyTypeRef] = useStateRef("");
  const [reviewJourneyId, setReviewJourneyId, reviewJourneyIdRef] =
  useStateRef(null);
  const [limit, setLimit, limitRef] = useStateRef(5);
  const [offset, setOffset, offsetRef] = useStateRef(
    isExecutionHistory ? -1 : 0
  );
  const [isLoading, setIsLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [hasMoreQuestions, setHasMoreQuestions, hasMoreQuestionsRef] =
  useStateRef(true);
  const [authToken, setAuthToken] = useState(null);
  const bottomTriggerRef = useRef(null);
  const [
  reviewSubjectMasterUuid,
  setReviewSubjectMasterUuid,
  reviewSubjectMasterUuidRef] =
  useStateRef("");
  const initializeAuthToken = async () => {
    try {
      const token = await getAuthToken();
      setAuthToken(token);
    } catch (error) {
      console.error("Error getting auth token:", error);
      setAuthToken(null);
    }
  };

  // Fix: Initialize auth token when component mounts
  useEffect(() => {
    initializeAuthToken();
  }, []);
  const [
  reviewTopicMasterUuid,
  setReviewTopicMasterUuid,
  reviewTopicMasterUuidRef] =
  useStateRef("");
  const [
  learnProgressDetails,
  setLearnProgressDetails,
  learnProgressDetailsRef] =
  useStateRef({});

  const [triggerNextProgress, setTriggerNextProgress, triggerNextProgressRef] =
  useStateRef(false);
  const [endIndex, setEndIndex, endIndexRef] = useStateRef(null);

  // Use the custom hook to handle chat updates and pending chat ids extraction
  usePendingChatUpdater(questionsDataRef?.current, setQuestionsData);

  useEffect(() => {
    setReviewScreen(false);
    if (!isExecutionHistory) {
      setClearAllBottomButtons(true);
    }
    openLearnSideMenu && toggleLearnDrawer();
    isStandaloneWithSubjectMapping && openPracSideMenu && togglePracDrawer();
    updateQuestionsData();
  }, []);

  useEffect(() => {
    setJourneyData([]);
    setQuestionsData([]);
    setLearnProgressDetails({});
  }, [reviewJourneyIdRef?.current]);

  const updateQuestionsData = async () => {
    setHasMoreQuestions(true);
    setOffset(isExecutionHistory ? -1 : 0);
    setReviewJourneyId(journeyId || StorageService.getItem("ReviewJourneyId"));
    if (!isExecutionHistory) {
      setSubjectName(StorageService.getItem("subjectName"));
      setTopicName(StorageService.getItem("topicName"));
      setSubTopicName(StorageService.getItem("subTopicName"));
      // StorageService.setItem("subjectMasterUUid", subjectMasterUuid);
      // StorageService.setItem("topicMasterUUid", topicMasterUuid);
      setReviewSubjectMasterUuid(
        subjectMasterUuid || StorageService.getItem("subjectMasterUUid") || ""
      );
      setReviewTopicMasterUuid(
        topicMasterUuid || StorageService.getItem("topicMasterUUid") || ""
      );
    }
    if (
    isNotEmptyOrNull(reviewJourneyIdRef?.current) ||
    isNotEmptyOrNull(journeyId))
    {
      await fetchLearningPathProgress();
    }
  };
  const handleNavItemCLick = () => {
    toggleLearnDrawer();
    updateQuestionsData();
  };

  const fetchLearningPathProgress = useCallback(async () => {
    if (isLoading || !hasMoreQuestionsRef.current) {
      return;
    }
    setIsLoading(true);
    try {
      const activeJourneyId = reviewJourneyIdRef?.current;
      const response = await getJourneyInfo(
        activeJourneyId,
        limitRef.current,
        offsetRef.current
      );
      if (isExecutionHistory) {
        if (
        offsetRef.current.toString().replace("-", "") >
        response?.[0]?.page_count ||
        response?.[0]?.page_count === undefined)
        {
          setHasMoreQuestions(false);
          isHistoryLoaded(true);
          setExecutionHistoryLoaded(true);
          setTriggerNextProgress(false);
          setIsLoading(false);
          return;
        }
      } else if (offsetRef?.current + 1 > response?.[0]?.page_count) {
        // console.log("No more questions available");
        setHasMoreQuestions(false);
        isHistoryLoaded(true);
        setExecutionHistoryLoaded(true);
        setTriggerNextProgress(false);
        setIsLoading(false);
        return;
      }

      // console.log("RESPONSE", response);

      if (response[0]?.journey_type === "learn") {
        setLearnProgressDetails({
          total_steps: response[0]?.total_steps,
          current_step_index: response[0]?.current_step_index,
          current_step_eval_state: response[0]?.current_step_eval_state,
          journey_type: response[0]?.journey_type
        });
      }

      const journeyResponse = response[0];
      if (journeyResponse) {
        setJourneyType(journeyResponse.journey_type);
        if (isExecutionHistory) {
          setJourneyData([
          ...journeyResponse.learning_path_journey,
          ...journeyDataRef.current]
          );
        } else {
          setJourneyData([
          ...journeyDataRef.current,
          ...journeyResponse.learning_path_journey]
          );
        }

        const learningPathJourney = Array.isArray(
          journeyResponse.learning_path_journey
        ) ?
        journeyResponse.learning_path_journey :
        [];
        setJourneyType(journeyResponse.journey_type || "");
        setTaskType(journeyResponse.journey_type || "");
        await fetchQuestions(learningPathJourney);

        setOffset((prevOffset) =>
        isExecutionHistory ? prevOffset - 1 : prevOffset + 1
        );
      } else {
        console.error("Error in response");
        setHasMoreQuestions(false);
      }
    } catch (error) {
      console.error("Error fetching learning path progress:", error);
      setHasMoreQuestions(false);
    } finally {
      setIsLoading(false);
      setHasFetched(true);
    }
  }, [
  triggerNextProgressRef?.current,
  reviewJourneyIdRef.current,
  limitRef,
  offsetRef,
  isLoading,
  hasMoreQuestionsRef.current]
  );

  useEffect(() => {
    let questionsNeeded = questionsDataRef?.current?.filter((item) => {
      return item?.count !== -1;
    });
    // console.log("END INDEX REF", endIndexRef?.current);
    // console.log("QUESTIONDATAREF", questionsNeeded);
    // console.log("TRIGGER NEXT PROGRESS", triggerNextProgressRef?.current);
    if (endIndexRef?.current < questionsNeeded.length) {
      setTriggerNextProgress(false);
    }
    if (triggerNextProgressRef?.current) {
      fetchLearningPathProgress();
    }
  }, [
  triggerNextProgressRef?.current,
  fetchLearningPathProgress,
  endIndexRef?.current]
  );

  useEffect(() => {
    // Observer to fetch more questions when bottom trigger is visible
    const bottomObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !isLoading && hasMoreQuestionsRef.current) {
          fetchLearningPathProgress();
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );

    const bottomTrigger = bottomTriggerRef.current;
    if (bottomTrigger) {
      bottomObserver.observe(bottomTrigger);
    }
    return () => {
      if (bottomTrigger) {
        bottomObserver.unobserve(bottomTrigger);
      }
    };
  }, [fetchLearningPathProgress, isLoading, hasMoreQuestionsRef.current]);

  const fetchQuestions = async (journey = []) => {
    try {
      if (!Array.isArray(journey) || journey.length === 0) {
        // setQuestionsData([]); // Set empty data if journey is empty
        return;
      }

      let chatData = new Set(); // Initialize as a Set
      let modifiedQuestions = [];

      // Process journey items based on length
      const journeysToProcess = journey.length > 1 ? journey : [journey[0]];

      for (const item of journeysToProcess) {
        const questions =
        item?.learning_mode?.toLowerCase() === learningModes.FactualBasket ?
        isNotEmptyOrNull(item?.contents?.[0]?.content_details) ?
        item?.contents :
        item?.contents?.[0]?.questions?.filter(
          (q) => q.result !== null
        ) || [] :
        item?.questions?.filter((q) => q.result !== null) || [];
        if (
        item?.learning_mode?.toLowerCase() === learningModes.FactualBasket &&
        isNotEmptyOrNull(item?.contents?.[0]?.content_details))
        {
          modifiedQuestions = [
          ...modifiedQuestions,
          {
            questionObj: {
              dialog_entry_script: item?.entry_script,
              exitScript: item?.exit_script?.content?.[0]?.text_layout,
              contents: questions
            }
          }];

        } else {
          const chatIds = new Set();

          const itemQuestions = questions.map((question, index) => {
            let userAnswer = {};
            try {
              userAnswer =
              item?.learning_mode?.toLowerCase() ===
              learningModes.FactualBasket ?
              JSON.parse(decodeURIComponent(question.user_answer)) :
              JSON.parse(question.user_answer);
            } catch {}

            if (!isEmptyOrNull(userAnswer?.chatId)) {
              chatIds.add(userAnswer.chatId);
              chatData.add(userAnswer.chatId); // Add chatId to the main chatData set
            }

            // Add chat IDs from sub_questions if they exist
            if (isNotEmptyOrNull(userAnswer?.sub_questions)) {
              userAnswer.sub_questions.forEach((subQ) => {
                if (!isEmptyOrNull(subQ?.chat_id)) {
                  chatIds.add(subQ.chat_id);
                  chatData.add(subQ.chat_id);
                }
              });
            }

            const questionRef =
            question.question_sequence === "main_question" ?
            React.createRef() :
            null;

            return {
              ref: questionRef,
              questionObj: {
                dialog_entry_script: index === 0 ? item?.entry_script : {},
                exitScript:
                index === questions.length - 1 ?
                item?.exit_script?.content?.[0]?.text_layout :
                "",
                ...(question?.question_details || {}) // Spread only if it's an object
              },
              question_sequence: question.question_sequence,
              count:
              question.question_sequence === "main_question" ?
              question?.main_question_count :
              -1,
              userAnswer
            };
          });
          modifiedQuestions = [...modifiedQuestions, ...itemQuestions];
          // console.log("Journey data", modifiedQuestions);
        }
      }

      // Fetch chat data for all unique chat IDs
      chatData = chatData.size > 0 ? await getChatInfoByIds([...chatData]) : [];

      // Prepare and set final data
      const finalData = handlePrepareData(modifiedQuestions, chatData);
      let questionsList = [];
      if (isExecutionHistory) {
        questionsList = [...finalData, ...questionsDataRef.current];
        setQuestionsData(questionsList);
      } else {
        questionsList = [...questionsDataRef.current, ...finalData];
        setQuestionsData(questionsList);
      }
      setReviewQuestionsData(questionsList);

      // Process data for display
      let reviewQuestion = [];
      let chatHistoryList = [];

      questionsDataRef.current?.map((item, index) => {
        let questionObjWithUserAnswer = {
          ...item?.questionObject,
          userAnswer: item?.userAnswer
        };
        reviewQuestion = [...reviewQuestion, questionObjWithUserAnswer];
        chatHistoryList = [...chatHistoryList, item.history];
      });

      // Store current displayed questions and chat history
      // Fix: Store the latest question from displayedQues (if it exists)
      const latestQuestion =
      displayedQues.length > 0 ?
      displayedQues[displayedQues.length - 1] :
      null;
      const latestChatHistory =
      chatHistory.length > 0 ? chatHistory[chatHistory.length - 1] : null;

      // Clear temporary arrays
      setDisplayedQues([]);
      setChatHistory([]);

      // Combine data without creating duplicates
      let displayedQuestions = reviewQuestion;
      let chatHistoryArray = chatHistoryList;

      // Add the latest question and chat history if they exist and aren't already included
      if (latestQuestion) {
        // Check if the latest question is not already in reviewQuestion (simplified check)
        const questionExists = reviewQuestion.some(
          (q) => JSON.stringify(q) === JSON.stringify(latestQuestion)
        );

        if (!questionExists) {
          displayedQuestions = [...displayedQuestions, latestQuestion];
        }
      }

      const refImages = {}; // Create internal variable

      displayedQuestions.map((item, index) => {
        let questionObj = item;
        const answrImages = handleExtractAnswerImages(questionObj);
        const optionImages = handleExtractQuestionImages(questionObj);
        refImages[index] = [...answrImages, ...optionImages]; // Use internal variable
      });

      setAssistantRefImages(refImages);

      console.log("Assistant Ref Images", refImages);

      if (latestChatHistory) {
        // Simple check to avoid duplicate chat history
        const historyExists = chatHistoryList.some(
          (h) => JSON.stringify(h) === JSON.stringify(latestChatHistory)
        );

        if (!historyExists) {
          chatHistoryArray = [...chatHistoryArray, latestChatHistory];
        }
      }

      // Set state with the combined data
      setChatHistory(chatHistoryArray);
      const questionIndex =
      displayedQuestions.length > 0 ? displayedQuestions.length - 1 : 0;
      console.log(questionIndex, "questionIndex");
      setCurrentQuestionIndex(questionIndex);
      setDisplayedQues(displayedQuestions);
    } catch (error) {
      console.error("Error fetching questions:", error);
      //setQuestionsData([]); // Set empty data in case of error
    }
  };

  const handlePrepareData = (questions, chatInfo) => {
    return questions.map((item, index) => {
      const chatID = item.userAnswer?.chatId;
      let history = chatInfo?.[chatID]?.history || [];
      let summary = chatInfo?.[chatID]?.summary || "";
      history = history?.map((chat) => ({
        ...chat,
        content: chat.content || ""
      }));

      let questionObj = { ...item.questionObj, showGreen: true };
      if (
      questionObj?.question_type === "9" ||
      questionObj?.question_type === "10")
      {
        questionObj = {
          ...questionObj,
          sub_question: questionObj.sub_question?.map((subQues) => ({
            ...subQues,
            showGreen: true
          }))
        };
      }

      // Add sub-questions history to the main history array
      if (isNotEmptyOrNull(item.userAnswer?.sub_questions)) {
        item.userAnswer.sub_questions.forEach((subQ) => {
          if (
          isNotEmptyOrNull(subQ?.chat_id) &&
          isNotEmptyOrNull(chatInfo?.[subQ?.chat_id]))
          {
            history.push({
              [subQ.chat_id]:
              chatInfo[subQ.chat_id]?.history?.map((chat) => ({
                ...chat,
                content: chat.content || ""
              })) || []
            });
          }
        });
      }

      return {
        ref: item.ref,
        questionObject: questionObj,
        userAnswer: item.userAnswer,
        history: history || [],
        summary,
        question_sequence: item?.question_sequence,
        count: item?.count
      };
    });
  };

  const handleNavigate = async (item) => {
    const { questionObject: questionObj, userAnswer } = item;
    const state = {
      journeyId: journeyId || reviewJourneyIdRef?.current,
      questionObj,
      userAnswer
    };
    await StorageService.setItem("assesmentInfo", JSON.stringify(state));
    // console.log("state", subjectMasterUuid, topicMasterUuid);
    navigate(`${urlString}/practice`, {
      state: {
        parentRoute: "Assesment",
        subjectMasterUuid: subjectMasterUuid,
        topicMasterUuid: topicMasterUuid
      }
    });
  };

  const closeLearnSideNav = () => {
    toggleLearnDrawer();
  };

  const handleNextProgress = (clickedIndex, endIndex) => {
    // console.log("handleNextProgress triggered bro", clickedIndex, endIndex);
    setTriggerNextProgress(true);
    setEndIndex(endIndex);
  };

  const drawerStyle = `${PracticeStyles["drawer"]} ${
  openPracSideMenu ? PracticeStyles["review-drawer-open"] : ""}`;


  let emptyState = questionsDataRef?.current?.length === 0;

  return (
    <Box
      sx={
      TutorReviewModeStyles(isReviewRoute, emptyState, isExecutionHistory)?.
      mainContainer
      }>

      {isStandaloneWithSubjectMapping && openPracSideMenu && !isMobile &&
      <div className={drawerStyle}>
          <Image
          cursor={"pointer"}
          onClick={togglePracDrawer}
          src={RightArrowIcon} />

          <PracticeHistoryList />
        </div>
      }
      {isStandaloneWithSubjectMapping && openPracSideMenu && isMobile &&
      <PracticeHistoryBottomSheet />
      }
      {!isExecutionHistory &&
      isNotEmptyOrNull(reviewSubjectMasterUuidRef?.current) &&
      isNotEmptyOrNull(reviewTopicMasterUuidRef?.current) &&
      <LearnSideNav
        isOpen={openLearnSideMenu}
        onSubtopicClick={handleNavItemCLick}
        onClose={closeLearnSideNav}
        isReviewScreen={true}
        subjectMasterUuid={reviewSubjectMasterUuidRef?.current}
        topicMasterUuid={reviewTopicMasterUuidRef?.current} />

      }
      {/* Loading State of Review Mode */}
      {/* {isExecutionHistory && isLoading && (
         <Lottie
           loop
           animationData={loading}
           play
           style={{
             width: "60px",
             height: "60px",
           }}
         />
        )} */}
      {/* Empty Journey Case */}
      {hasFetched &&
      !isExecutionHistory &&
      questionsDataRef.current?.length === 0 &&
      !isLoading &&
      <Box sx={TutorReviewModeStyles()?.emptyJourneyContainer}>
            <Image
          src={accordion_images.noUpdates}
          width={"200px"}
          height={"150px"} />

            <Box sx={TutorReviewModeStyles()?.emptyJourneyContainerTitle}>
              Hey! There's nothing here.
            </Box>
            <Box sx={TutorReviewModeStyles()?.emptyJourneyContainerDescription}>
              When you start your journey, you'll see the review.
            </Box>
          </Box>
      }
      {isExecutionHistory && hasMoreQuestionsRef.current &&
      <Box
        ref={bottomTriggerRef}
        width="100%"
        padding="10px"
        backgroundColor="transparent"
        justifyContent="center"
        alignItems="center"
        display={"flex"}>
      </Box>
      }
      {/*  */}
      {!isExecutionHistory && questionsDataRef.current?.length !== 0 &&
      <Box sx={TutorReviewModeStyles()?.reviewPresenterContainer}>
          <ReviewPresenter
          authToken={authToken}
          dataType={"studentJourneyMode"}
          questions={questionsDataRef.current}
          assistantRefImages={assistantRefImages}
          isReviewScreen={true}
          onAnswerChanged={() => {}}
          onAnswerSubmitted={() => {}}
          isFactual={false}
          commonProps={commonProps}
          handleNavigate={handleNavigate}
          questionRefs={[]}
          journeyData={journeyDataRef.current}
          taskType={journeyTypeRef?.current}
          handleNextProgress={handleNextProgress}
          pageValue={offsetRef?.current}
          learnProgressDetails={learnProgressDetailsRef?.current}
          reviewJourneyId={reviewJourneyIdRef?.current} />

          {!isExecutionHistory && hasMoreQuestionsRef.current &&
        <Box
          ref={bottomTriggerRef}
          height="10px"
          width="100%"
          padding="10px"
          backgroundColor="transparent"
          justifyContent="center"
          alignItems="center"
          display={"flex"}>

              {isLoading &&
          <Lottie
            loop
            animationData={loading}
            play
            style={{
              width: "60px",
              height: "60px"
            }} />

          }
            </Box>
        }
        </Box>
      }
      {!isExecutionHistory && isReviewRoute &&
      <Box sx={TutorReviewModeStyles()?.editorBox}>
          <PlainInput isDisable={true} buttons={buttons} hideFormula={true} />
          <Box
          height={"24px"}
          bgColor={"#F5F4FA"}
          //bgColor={"red"}
        ></Box>
        </Box>
      }
    </Box>);

};

export default React.memo(TutorReviewMode);